import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import '../App.css'; // Dacă ai clase globale
import ProiecteSection from '../components/home/ProiecteSection';
import AddPersonModal from '..//components/helpers/AddPersonModal';
import StatsBar from '../components/home/StatsBar';

// Token-ul și Header-ul pentru API
const TOKEN = "unwantedtok";
const AUTH_HEADER = {
  Authorization: `Bearer ${TOKEN}`,
};

function Home() {
  const [showModal, setShowModal] = useState(false);
  const API_BASE = "https://prdp-api.suport-949.workers.dev/api/inscrieri-membri";

  const handleAddPerson = async (person) => {
    const newPerson = { ...person, timestamp: new Date().toISOString() };
    try {
      const response = await fetch(API_BASE, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...AUTH_HEADER },
        body: JSON.stringify(newPerson),
      });
      if (response.ok) setShowModal(false);
    } catch (error) {
      console.error("Eroare de rețea:", error);
    }
  };

  return (
    <>
      {/* Secțiunea Hero cu Background Image */}
      <header className="hero-section text-center">
        {/* Overlay-ul care face textul lizibil peste imagine */}
        <div className="hero-overlay"></div>
        
        <Container className="position-relative hero-content">
          {/* Badge-ul de deasupra titlului */}
          <div className="hero-badge mx-auto mb-4">
            PROIECTE PENTRU VIITOR
          </div>

          <h1 className="fw-bold hero-title">
            Proiectele PRDP <br /> pentru România
          </h1>
          
          <p className="hero-subtitle mx-auto mt-4">
            Lucrăm pentru o Românie dreaptă, unită și prosperă. Descoperă inițiativele noastre pentru un viitor mai bun.
          </p>

          <div className="d-flex justify-content-center gap-3 mt-5 flex-wrap">
            {/* Buton 1: Duce spre secțiunea de proiecte */}
            <Button 
              className="btn-hero-primary px-5 py-3 rounded-pill fw-bold"
              onClick={() => {
                // Opțional: scroll smooth către secțiunea de proiecte
                document.getElementById('proiecte-section')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Vezi Proiectele
            </Button>
            
            {/* Buton 2: Deschide modalul de înscriere în partid */}
            <Button 
              className="btn-hero-secondary px-5 py-3 rounded-pill fw-bold"
              onClick={() => setShowModal(true)}
            >
              Vino în echipă
            </Button>
          </div>
        </Container>
      </header>
      
      <StatsBar />

      {/* Am adăugat un ID aici ca să poată face scroll butonul "Vezi Proiectele" */}
      <div id="proiecte-section">
        <ProiecteSection />
      </div>

      {/* Modalul de înscriere apelat de al doilea buton */}
      <AddPersonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSave={handleAddPerson}
        title="Înscriere ca membru / voluntar"
      />
    </>
  );
}

export default Home;
